import axios from '../../api/axiosInstance';
import { STATUS, getProjectId, extractErrorInfo } from './sharedfunction';

export async function getSchedulesForGroup({ testGroupId } = {}) {
  try {
    const projectId = getProjectId();
    if (!projectId || !testGroupId) {
      return { status: STATUS.ERROR, error: 'Project ID and test group ID are required' };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/${projectId}/test-launch/schedule/${testGroupId}`,
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || { rows: [], total: 0 },
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error('Error fetching schedules:', error);
    return extractErrorInfo(error);
  }
}

export async function getSchedule({ scheduleId } = {}) {
  try {
    const projectId = getProjectId();
    if (!projectId || !scheduleId) {
      return { status: STATUS.ERROR, error: 'Project ID and schedule ID are required' };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/${projectId}/test-launch/schedule/detail/${scheduleId}`,
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error('Error fetching schedule:', error);
    return extractErrorInfo(error);
  }
}

export async function createSchedule(payload = {}) {
  try {
    const projectId = getProjectId();
    if (!projectId) {
      return { status: STATUS.ERROR, error: 'Project ID is required' };
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/${projectId}/test-launch/schedule`,
      payload,
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error('Error creating schedule:', error);
    return extractErrorInfo(error);
  }
}

export async function updateSchedule({ scheduleId, ...payload } = {}) {
  try {
    const projectId = getProjectId();
    if (!projectId || !scheduleId) {
      return { status: STATUS.ERROR, error: 'Project ID and schedule ID are required' };
    }

    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/${projectId}/test-launch/schedule/${scheduleId}`,
      payload,
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error('Error updating schedule:', error);
    return extractErrorInfo(error);
  }
}

export async function pauseSchedule({ scheduleId } = {}) {
  try {
    const projectId = getProjectId();
    if (!projectId || !scheduleId) {
      return { status: STATUS.ERROR, error: 'Project ID and schedule ID are required' };
    }

    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/${projectId}/test-launch/schedule/${scheduleId}/pause`,
      {},
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return { status: STATUS.SUCCESS, data: response?.data?.data, message: response?.data?.message };
    }

    return { status: STATUS.ERROR, error: response?.data?.message || response?.data?.error };
  } catch (error) {
    console.error('Error pausing schedule:', error);
    return extractErrorInfo(error);
  }
}

export async function resumeSchedule({ scheduleId } = {}) {
  try {
    const projectId = getProjectId();
    if (!projectId || !scheduleId) {
      return { status: STATUS.ERROR, error: 'Project ID and schedule ID are required' };
    }

    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/${projectId}/test-launch/schedule/${scheduleId}/resume`,
      {},
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return { status: STATUS.SUCCESS, data: response?.data?.data, message: response?.data?.message };
    }

    return { status: STATUS.ERROR, error: response?.data?.message || response?.data?.error };
  } catch (error) {
    console.error('Error resuming schedule:', error);
    return extractErrorInfo(error);
  }
}

export async function deleteSchedule({ scheduleId } = {}) {
  try {
    const projectId = getProjectId();
    if (!projectId || !scheduleId) {
      return { status: STATUS.ERROR, error: 'Project ID and schedule ID are required' };
    }

    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/${projectId}/test-launch/schedule/${scheduleId}`,
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return { status: STATUS.SUCCESS, data: response?.data?.data, message: response?.data?.message };
    }

    return { status: STATUS.ERROR, error: response?.data?.message || response?.data?.error };
  } catch (error) {
    console.error('Error deleting schedule:', error);
    return extractErrorInfo(error);
  }
}
